import React from 'react';
import { Box } from '@mui/material';
import { Bar, BarChart, CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { useWidgetFrame } from '../frameContext';
import { chartTheme } from './chartTheme';

/**
 * Bar or line chart (design template 7) with the legacy landing page look.
 * data: [{ label, value }]
 */
export default function ChartBody({ kind = 'bar', data = [], color, tickFormatter, valueFormatter, tooltipLabel }) {
  const frame = useWidgetFrame();
  // Desktop rows give the chart a definite height; mobile rows are auto, where a 100 % height
  // resolves to nothing and the chart vanished. A fixed height on mobile keeps it drawn.
  const mobile = Boolean(frame?.isMobile);
  const stroke = color || (kind === 'line' ? chartTheme.line.stroke : chartTheme.bar.fill);
  const common = {
    data,
    margin: { top: 8, right: 12, left: -8, bottom: 0 },
  };
  const axes = (
    <>
      <CartesianGrid vertical={false} stroke={chartTheme.grid} strokeDasharray="3 3" />
      <XAxis dataKey="label" axisLine={false} tickLine={false} tick={chartTheme.axis} />
      <YAxis axisLine={false} tickLine={false} tick={chartTheme.tick} tickFormatter={tickFormatter} width={44} />
      <Tooltip
        cursor={{ fill: 'rgba(49,130,206,0.06)' }}
        formatter={(value) => [valueFormatter ? valueFormatter(value) : value, tooltipLabel]}
        contentStyle={chartTheme.tooltip}
        itemStyle={{ color: 'white' }}
        labelStyle={{ color: 'white' }}
      />
    </>
  );
  return (
    <Box data-widget-chart="" sx={{ flex: mobile ? 'none' : 1, height: mobile ? 220 : undefined, minHeight: 0, p: 1.5, pt: 1 }}>
      <ResponsiveContainer width="100%" height="100%">
        {kind === 'line' ? (
          <LineChart {...common}>
            {axes}
            <Line type="monotone" dataKey="value" stroke={stroke} strokeWidth={chartTheme.line.strokeWidth} dot={{ ...chartTheme.line.dot, fill: stroke }} isAnimationActive={false} />
          </LineChart>
        ) : (
          <BarChart {...common} barSize={32}>
            {axes}
            <Bar dataKey="value" fill={stroke} radius={chartTheme.bar.radius} isAnimationActive={false} />
          </BarChart>
        )}
      </ResponsiveContainer>
    </Box>
  );
}
